import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import business from "./modules/business";
import cache from "./modules/cache";
import user from "./modules/user";
import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    business,
    cache,
    user
  },
  getters
});

export default store;
